import { useEffect } from "react";
import { SITE_URL } from "@/content";

const upsertMeta = (selector, create, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertNamedMeta = (name, content) =>
  upsertMeta(`meta[name="${name}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("name", name);
    return m;
  }, content);

const upsertPropMeta = (property, content) =>
  upsertMeta(`meta[property="${property}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("property", property);
    return m;
  }, content);

/**
 * Leichtgewichtige SEO-Komponente: setzt Title, Description, Keywords,
 * Canonical und OpenGraph/Twitter Tags pro Route.
 */
export const Seo = ({ title, description, path = "/", keywords }) => {
  useEffect(() => {
    document.title = title;
    upsertNamedMeta("description", description);
    if (keywords) upsertNamedMeta("keywords", keywords);

    const url = `${SITE_URL}${path}`;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    upsertPropMeta("og:title", title);
    upsertPropMeta("og:description", description);
    upsertPropMeta("og:url", url);
    upsertPropMeta("og:type", "website");
    upsertPropMeta("og:locale", "de_DE");
    upsertPropMeta("og:site_name", "Shibuya Anime & TCG Store Köln");
    upsertPropMeta("og:image", `${SITE_URL}/assets/logo.png`);
    upsertNamedMeta("twitter:card", "summary_large_image");
    upsertNamedMeta("twitter:title", title);
    upsertNamedMeta("twitter:description", description);
  }, [title, description, path, keywords]);

  return null;
};
